import { _ } from 'lodash';
import axios from "axios";
import { mapState, mapActions, mapGetters } from 'vuex';
import {
    nameService,
    kebabService,
    conf_api,
    conf_actions,
    conf_arg,
    conf_service_data,
    conf_auto,
} from "@/autolib/config.js";

var data = (name) => {
    var data = {};
    conf_auto.forEach(ca => {
        const service = ca.target == "self" ? "" : ca.target;
        data[nameService([name, "abort-signal", service])] = { };
        data[nameService([name, "clear-signal", service])] = { };
        data[nameService([name, "timer-local", service])] = 500;
        Object.keys(conf_actions).forEach(key => {
            data[nameService([name, key, "customize-detail"])] = {};
            data[nameService([name, key, "customize-list"])] = [];
            data[nameService([name, key, "access", "counter"])] = 0;
            data[nameService([name, key, "action", "counter"])] = 0;
            data[nameService([name, key, "busy"])] = false;
            data[nameService([name, key, "timer"])] = 300;
            data[nameService([name, key, "action-wait"])] = null;
            data[nameService([name, key, "date-update-local"])] = null;
            data[nameService([name, key, "api-local", service])] = {};
            data[nameService([name, key, "stats-local", service])] = {};
            data[nameService([name, key, "payload-local", service])] = { params: {} };
            data[nameService([name, key, "local", service])] = key == "array" ? [] : {};
            data[nameService([name, key, "reload-everywhere-enabled", service])] = false;
            data[nameService([name, key, "reload-somewhere-enabled", service])] = false;
            data[nameService([name, key, "reload-callback-enabled", service])] = false;
            data[nameService([name, key, "component-ready", service])] = false;
            conf_service_data.filter(csd => !csd.not || csd.not.indexOf("data") < 0).forEach(e => {
                if(e.listorobj){
                    data[nameService([name, key, e.service, "local", service])] = key == "array" ? [] : {};
                }else{
                    data[nameService([name, key, e.service, "local", service])] = e.conf.default || undefined;
                }
            });
            conf_service_data.filter(csd => !csd.not || csd.not.indexOf("data") > -1).forEach(e => {
                data[nameService([name, key, "status", e.service, service])] = false;
                data[nameService([name, key, "status", e.service, "local", service])] = false;
            })
        });
    });
    return data;
}

var emits = (name) => {
    var data = [];
    conf_auto.forEach(ca => {
        const service = ca.target == "self" ? "" : ca.target;
        conf_service_data.filter(csd => !csd.not || csd.not.indexOf("emit") < 0).forEach(e => {
            Object.keys(conf_actions).forEach(key => {
                data.push(kebabService([name, key, e.service, service]))
            });
        });
    });
    return data;
};

var props = (name) => {
    var data = {};
    conf_auto.forEach(ca => {
        const service = ca.target == "self" ? "" : ca.target;
        Object.keys(conf_actions).forEach(key => {
            data[nameService([name, key, "date-update", service])] = { type: [Number, Date] };
            data[nameService([name, key, "api", service])] = { type: Object, default: () => ({})};
            data[nameService([name, key, "stats", service])] = { type: [Array, Object], default: () => ({})};
            data[nameService([name, key, service])] = { type: key == "array" ? Array : Object, default: key == "array" ? [] : {} };
        });
        conf_service_data.filter(csd => !csd.not || csd.not.indexOf("prop") < 0).forEach(e => {
            data[nameService([name, e.service, "enable", service])] = { type: Boolean, default: false };
            if(e.listorobj){
                Object.keys(conf_actions).forEach(key => {
                    data[nameService([name, key, e.service, service])] = { type: key == "array" ? Array : Object, default: key == "array" ? [] : {} };
                });
            }else{
                data[nameService([name, e.service, service])] = e.conf
            }
        });
        conf_service_data.filter(csd => csd.not && csd.not.indexOf("prop") > -1).forEach(e => {
            data[nameService([name, "status-is", e.service, service])] = { type: [Boolean, Object], default: false };
        });
    });
    return data;
};

var watch = (name) => {
    var data = {};

    // Service or Contact
    conf_auto.forEach(ca => {
        const service = ca.target == "self" ? "" : ca.target;

        // Self or Array
        Object.keys(conf_actions).forEach(key => {
            // Listener queryset onchange [state]->reload-everywhere-counter
            data[nameService([name, key, "reload-everywhere-counter", service])] = {
                handler: nameService([name, key, "reload-everywhere", service])
            };
            // Listener queryset if component name in [state]->reload-somewhere-list
            data[nameService([name, key, "reload-somewhere-list", service])] = {
                handler: nameService([name, key, "reload-somewhere", service]), deep: true,
            };
            // Listener queryset if component name in [state]->reload-callback
            data[nameService([name, key, "reload-callback-counter", service])] = {
                handler: nameService([name, key, "reload-callback", service]), deep: true,
            };
            // Listener to set prop data to local data
            data[nameService([name, key, service])] = {
                handler: nameService([name, "prop-to-local", service]), deep: true,
            }
            // Listener to reload data
            data[nameService([name, key, "reload", service])] = {
                handler: nameService([name, "reload", key, "local", service]), deep: true,
            }
        });
    });
    return data;
};

var computed = (name, store) => {
    var state = [], getters = [];

    // Service or Contact
    conf_auto.forEach(ca=> {
        const service = ca.target == "self" ? "" : ca.target;

        // Some store functions
        getters.push(nameService([name, "http", service]));
        getters.push(nameService([name, "get-api", service]));
        getters.push(nameService([name, "get-api-detail", service]));
        getters.push(nameService([name, "get-api-form", service]));
        getters.push(nameService([name, "get-api-form-detail", service]));
        getters.push(nameService([name, "filter-by", service]));
        getters.push(nameService([name, "find-by", service]));
        getters.push(nameService([name, "filter-multiple-by", service]));
        getters.push(nameService([name, "find-multiple-by", service]));

        // State
        state.push(nameService([name, "page-limit", service]));
        Object.keys(ca.data).forEach(key => {
            state.push(nameService([name, key, "reload-everywhere-counter", service]));
            state.push(nameService([name, key, "reload-somewhere-list", service]));
            state.push(nameService([name, key, "reload-callback-counter", service]));
            state.push(nameService([name, key, "state", service]))
        });
    });
    var data = { ...mapState(store, state), ...mapGetters(store, getters), };

    // Service or Contact
    conf_auto.forEach(ca=> {
        const service = ca.target == "self" ? "" : ca.target;


        data[nameService([name, "get-cancel-id", service])] = () => Math.random().toString(16).slice(2);

        // Self or Array
        Object.keys(ca.data).forEach(key => {
            data[nameService([name, key, "prop", service])] = function(){
                return this[nameService([name, key])];
            }
            conf_arg.forEach(a => {
                data[nameService([name, key, "in", a, service])] = function(){
                    const obj = this[nameService([name, key, a, service])];
                    const test = key == "array" ? obj.length : (obj && Object.keys(obj).length);
                    return test;
                }
            });
            data[nameService([name, key, "load", service])] = function(){
                for(var i=0; i <= conf_arg.length; i++){
                    if(this[nameService([name, key, "in", conf_arg[i], service])]){
                        return this[nameService([name, key, conf_arg[i], service])];
                    }
                }
                return key == "array" ? [] : {};
            }
        });

        // Go to -> config.js
        conf_service_data.forEach(e => {


            Object.keys(conf_actions).forEach(key => {
                data[nameService([name, key, "has", e.service, "local", service])] = function(){
                    const obj = this[nameService([name, key, e.service, "local", service])];
                    return key == "array" ? obj.length : (obj && Object.keys(obj).length);
                }
                data[nameService([name, key, "css", e.service, "local", service])] = function(){
                    return this[nameService([name, key, "has", e.service, "local", service])] ? e.service : "";
                }
            });
            if(e.listorobj){
                data[nameService([name, "is", e.service, "local", service])] = function(){
                    return [nameService([name, "is", e.service, "array-local", service])]
                };
                data[nameService([name, "is", e.service, "array-local", service])] = function(){
                    return this[nameService([name, "is", e.service, "array-local", service])]
                };
            }
        });
    });
    return data;
};

var methods = (name, store) => {

    // From store
    var actions = [
        nameService([name, "upload-document"]),
        nameService([name, "remove-document"]),
        nameService([name, "download-document"]),
        nameService([name, "remove-somewhere"]),
    ];
    conf_auto.forEach(ca => {
        const service = ca.target == "self" ? "" : ca.target;
        actions.push(nameService([name, "http-request", service]));
        Object.keys(conf_actions).forEach(key => {
            actions.push(nameService([name, key, "crud-evw-smw", service]));
            actions.push(nameService([name, key, "crud-callback", service]));
            actions.push(nameService([name, key, "single-action", service]));
            actions.push(nameService([name, key, "url-customize", service]));
            actions.push(nameService([name, key, "reporting-list", service]));
            actions.push(nameService([name, key, "reporting-detail", service]));
            actions.push(nameService([name, key, "reporting-global", service]));
            actions.push(nameService([name, "create", key, "state", service]));
            actions.push(nameService([name, "create-or-update", key, "state", service]));
            conf_actions[key].forEach(a => {
                actions.push(nameService([name, a, key, "state", service]));
            });
        });
    });
    var data = { ...mapActions(store, actions), };

    // Download a document with filename
    data[nameService([name, "document-download"])] = function(url, filename){
        const blob = new Blob([url.data], {});
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        if(filename){
            link.download = filename;
        }else{
            var cd = url.headers["content-disposition"];
            const fn = cd.match("filename=(.+)")[1]
            link.download = fn;
        }
        link.click();
        URL.revokeObjectURL(link.href);
    }
    // Downloads a document list
    data[nameService([name, "documents-download"])] = function(docs){
        docs.forEach(async doc => {
            this[nameService([name, "document-download"])](doc.url, doc.name);
        });
    }
    // Return a document url (or download if true)
    data[nameService([name, "document-url"])] = function(url, download){
        download ? this[nameService([url, "document-download"])](url) : window.open(url, "_blank");
    };
    // Return a document url viewer (or download if true)
    data[nameService([name, "document-viewer"])] = function(uid, download){
        var getUrl = window.location;
        var baseUrl = getUrl.protocol + "//" + getUrl.host + "/doc_viewer/"+uid+"/";
        download ? this[nameService([name, "document-download"])](baseUrl) : window.open(baseUrl, "_blank");
    }

    // Change url page base on vue-router
    data[nameService([name, "router-url"])] = function(view, params){ return {name: name+view, params}; }
    data[nameService([name, "get-url"])] = function(name, params) { this.$router.push({name, params}); }
    data[nameService([name, "go-to-url"])] = function(name, params) { this.$router.push({name, params}); }

    data[nameService([name, "get-url"])] = function(name, params) {
        this.$router.push({name, params});
    }

    // Change url page base on vue-router
    data[nameService([name, "router-url"])] = function(view, params){ return {name: name+view, params}; }
    data[nameService([name, "get-url"])] = function(name, params) { this.$router.push({name, params}); }
    data[nameService([name, "go-to-url"])] = function(name, params) { this.$router.push({name, params}); }

    conf_auto.forEach(ca => {
        // Service or Contact
        const service = ca.target == "self" ? "" : ca.target;



        // Params API paginator
        data[nameService([name, "params-paginator", service])] = function(page){
            const limit = this[nameService([name, "page", "limit", service])];
            return { offset: page*limit, limit }
        }

        // Self And Array
        Object.keys(conf_actions).forEach(key => {

            data[nameService([name, key, "get-export-detail", service])] = async function(cfg, id){
                var payload = this[nameService([name, "payload-get", service])]({reporting: cfg[0], file_type: cfg[1]});
                await this[nameService([name, key, "reporting-detail", service])]({ id, payload });
            },

            data[nameService([name, key, "get-export-global", service])] = async function(cfg, id){
                var payload = this[nameService([name, "payload-get", service])]({reporting: cfg[0], file_type: cfg[1]});
                await this[nameService([name, key, "reporting-global", service])]({ id, payload });
            },

            // Set options services
            data[nameService([name, key, "set-options", service])] = function(options){
                Object.assign(this[nameService([name, key, "options", service])], options);
            }

            // Set option if not exist or remove
            data[nameService([name, key, "set-or-remove-option", service])] = function(option, value){
                if(this[nameService([name, key, "options-local", service])][option])
                    delete this[nameService([name, key, "options-local", service])][option];
                else
                    this[nameService([name, key, "options-local", service])][option] = value;
            }

            // Reload queryset onchange [state]->reload-everywhere-counter
            data[nameService([name, key, "reload-everywhere-enable", service])] = function(){
                this[nameService([name, key, "reload-everywhere-enabled", service])] = true;
            }
            data[nameService([name, key, "reload-everywhere", service])] = function(){
                if(this[nameService([name, key, "reload-everywhere-enabled", service])]){
                    this[nameService([name, "reload", key, "local-clearable", service])]({ payload: {} });
                }
                if(this[nameService([name, key, "reload-signal-enabled", service])]){
                    this[nameService([name, key, "reload-signal", service])]();
                }
            }

            // Reload something on callback
            data[nameService([name, key, "reload-callback-enable", service])] = function(callback){
                this[nameService([name, key, "reload-callback-enabled", service])] = callback;
            }
            data[nameService([name, key, "reload-callback", service])] = function(){
                if(this[nameService([name, key, "reload-callback-enabled", service])]){
                    var fctn = this[nameService([name, key, "reload-callback-enabled", service])];
                    this[fctn]();
                }

            }

            // Signal
            data[nameService([name, key, "reload-signal-enable", service])] = function(callback){
                this[nameService([name, key, "reload-signal-enabled", service])] = callback;
            }
            data[nameService([name, key, "reload-signal", service])] = function(){
                const callback = this[nameService([name, key, "reload-signal-enabled", service])];
                this[callback]();
            }

            // Reload queryset if component name in [state]->reload-somewhere-list
            data[nameService([name, key, "reload-somewhere-enable", service])] = function(){
                this[nameService([name, key, "reload-somewhere-enabled", service])] = true;
            }
            data[nameService([name, key, "reload-somewhere", service])] = function(){
                if(this[nameService([name, key, "reload-somewhere-enabled", service])]){
                    var comp_name = this.$options.name;
                    var list = this[nameService(name, "reload-somewhere-list")];
                    if(comp_name && list.indexOf(comp_name) > -1){
                        this[nameService([name, "reload", key, "local", service])]();
                        this[nameService([name, "remove-somewhere"])](comp_name);
                    }
                }
            };

            data[nameService([name, key, "action-clearable"])] = function(action, payload, timer) {
                timer = timer != undefined ? timer : this[nameService([name, key, "timer"])];
                clearTimeout(this[nameService([name, key, "action-wait"])]);
                this[nameService([name, key, "action-wait"])] = setTimeout(() => {
                    if(payload) this[action](payload);
                    else this[action]();
                }, timer);
            }

            data[nameService([name, key, "update-key"])] = function(d, k){
                const changename = nameService([name, "self-change"]);
                const localname = nameService([name, "self-local"]);
                if(key == "self"){
                    if(this[localname][k] && this[localname][k] == this[changename][k])
                    this[localname] = d;
                }else{
                    const pos = d.findIndex(o => o[k] == this[localname][k]);
                    if(pos > -1) this[localname] = d[pos];
                }
            }
            data[nameService([name, key, "set-date-update"])] = function(d){
                this[nameService([name, key, "date-update-local"])] = d || Date.now();
            }
            data[nameService([name, key, "update"])] = function(d){
                this[nameService([name, key, "local"])] = d;
            }
            data[nameService([name, key, "update-uid"])] = function(d){
                this[nameService([name, key, "update-key"])](d, "uid");
            }
            data[nameService([name, key, "to-local"])] = function(d){
                this[nameService([name, key, "local"])] = d || this[nameService([name, key])];
            }
            data[nameService([name, key, "reset-to-local", service])] = function(){
                conf_service_data.forEach(e => {
                    this[nameService([name, key, e.service, "local", service])] = {};
                });
            }

            conf_service_data.forEach(e => {
                if(e.service == "action"){
                    data[nameService([name, key, "emit", e.service, service])] = function(action, d){
                        this.$emit(kebabService([name, key, e.service, service]),
                            {action, data: d || this[nameService([name, key, "local", service])]});
                    }
                }else{
                    data[nameService([name, key, "emit", e.service, service])] = function(d){
                        this.$emit(kebabService([name, key, e.service, service]),
                            d || this[nameService([name, key, "local", service])]);
                    }
                }
                data[nameService([name, key, e.service, "set-local", service])] = function(d){
                    this[nameService([name, key, e.service, "local", service])] =  d;
                }
                data[nameService([name, key, e.service, "add-to-local", service])] = function(d, k){
                    if(key == "array"){
                        k = k !== undefined ? k : "uid";
                        const i = this[nameService([name, key, e.service, "local", service])].findIndex(e => e[k] == d[k]);
                        if(i < 0) this[nameService([name, key, e.service, "local", service])].push(d);
                    }else{
                        this[nameService([name, key, e.service, "local", service])] = d || this[nameService([name, key, "local", service])];
                    }
                }
                data[nameService([name, key, e.service, "remove-to-local", service])] = function(d, k){
                    if(key == "array"){
                        k = k !== undefined ? k : "uid";
                        const i = this[nameService([name, key, e.service, "local", service])].findIndex(e => e[k] == d[k]);
                        if(i > -1) this[nameService([name, key, e.service, "local", service])].splice(i, 1);
                    }else{
                        this[nameService([name, key, e.service, "local", service])] = {};
                    }
                }
                data[nameService([name, key, e.service, "reset-local", service])] = function(){
                    this[nameService([name, key, e.service, "local", service])] = key == "array" ? [] : {};
                }
                data[nameService([name, key, e.service, "add-or-remove-local", service])] = function(d, k){
                    if(this[nameService([name, key, "has", e.service, "local", service])])
                        this[nameService([name, key, e.service, "remove-to-local", service])](d, k);
                    else
                        this[nameService([name, key, e.service, "add-to-local", service])](d, k);
                }
            });

            data[nameService([name, "prop-to-local", service])] = function(){
                this[nameService([name, key, "local", service])] = this[nameService([name, key, service])];
            };

            data[nameService([name, "enable-abort-signal", service])] = function(abort, msg="Due to new request"){
                if(this[nameService([name, "abort-signal", service])][abort]){
                    this[nameService([name, "abort-signal", service])][abort].abort(msg);
                }
                this[nameService([name, "abort-signal", service])][abort] = new AbortController();
                return this[nameService([name, "abort-signal", service])][abort].signal;
            };

            data[nameService([name, "clear-fct", service])] = function(action, callback, timer){
                if(this[nameService([name, "clear-signal", service])][action])
                    clearTimeout(this[nameService([name, "clear-signal", service])][action]);
                this[nameService([name, "clear-signal", service])][action] = setTimeout(() => {
                    callback();
                }, timer || this[nameService([name, "timer-local", service])]);
            };

            data[nameService([name, "clearable", service])] = function(action, payload, timer){
                clearTimeout(this[nameService([name, "wait-local", service])]);
                this[nameService([name, "wait-local", service])] = setTimeout(() => {
                    this[action]({ payload });
                }, timer || this[nameService([name, "timer-local", service])]);
            };

            conf_api.forEach(m => {
                data[nameService([name, "cancel", m, service])] = function(cancelid){
                    var cancel = this[nameService([name, "self-cancels-local", service])][cancelid];
                    if(cancel) cancel.cancel(`Cancel ${nameService([name, "cancel", m, service])}`);
                };

                data[nameService([name, "payload", m, service])] = function(payload, cancelid){
                    //const array_sort = nameService([name, "array", "sort", service]);
                    //const prop_sort = nameService([name, "sort", service]);
                    //this[array_sort] = this[array_sort] || this[prop_sort];
                    //if(this[array_sort]) payload.o = this[array_sort];

                    payload = payload != undefined ? { params: payload } : {};
                    if(cancelid != undefined){
                        this[nameService([name, "cancel", m, service])](cancelid);
                        const CancelToken = axios.CancelToken;
                        this[nameService([name, "self-cancels-local", service])][cancelid] = CancelToken.source();
                        payload.cancelToken = this[nameService([name, "self-cancels-local", service])][cancelid].token;
                    }
                    return payload;
                };

                data[nameService([name, "payload", "event", m, service])] = function(event, payload, cancelid){
                    event = event != undefined ? event : {};
                    payload = payload != undefined ? payload : {};
                    payload = Object.assign(event, payload);
                    return this[nameService([name, "payload", m, service])](payload, cancelid);
                };
            });

            conf_actions[key].forEach(a => {

                conf_api.forEach(m => {
                    data[nameService([name, "payload-reload", m, service])] = function(payload, cancelid){
                        payload = payload != undefined ? payload : {};
                        payload = Object.assign(this[nameService([name, key, "payload-local", service])].params, payload);
                        return this[nameService([name, "payload", m, service])](payload, cancelid);
                    };

                });

                var fctn_state = nameService([name, a, key, "state", service]);
                var fctn_local = nameService([name, a, key, "local", service]);
                var fctn_clrbl = nameService([name, a, key, "local-clearable", service]);
                switch(a){
                    case "set":
                        data[fctn_local] = async function({id, payload, abort, abortmsg}){
                            this[nameService([name, key, "busy"])] = true;
                            this[nameService([name, key, "access", "counter"])]++;
                            if(abort)
                                payload.signal = this[nameService([name, "enable-abort-signal", service])](abort, abortmsg);
                            const fct = nameService([name, "get", key, "state", service]);
                            var response = await this[fct]({id, payload});
                            response = response.data;
                            if(Array.isArray(response)){
                                this[nameService([name, key, "local", service])] = response;
                            }else if(response.results){
                                this[nameService([name, key, "local", service])] = response.results;
                                delete response.results;
                                this[nameService([name, key, "api-local", service])] = response;
                                if(response.stats)
                                    this[nameService([name, key, "stats-local", service])] = response.stats;
                            }else{
                                this[nameService([name, key, "local", service])] = response;
                            }
                            this[nameService([name, key, "payload-local", service])] = payload;
                            this[nameService([name, key, "busy"])] = false;
                            return response;
                        }
                        break;
                    case "more":
                        data[fctn_local] = async function({next, id, payload}){
                            const fct = nameService([name, "get", key, "state", service]);
                            const cancelid = this[nameService([name, "cancel-id", service])];
                            var response = await this[fct]({next, id, payload, cancelid});
                            response = response.data;
                            if(Array.isArray(response)){
                                this[nameService([name, key, "local", service])] = response;
                            }else if(response.results){
                                this[nameService([name, key, "local", service])] = this[nameService([name, key, "local", service])]
                                    .concat(response.results);
                                delete response.results;
                                this[nameService([name, key, "api-local", service])] = response;
                                if(response.stats)
                                    this[nameService([name, key, "stats-local", service])] = response.stats;
                            }
                            this[nameService([name, key, "payload-local", service])] = payload;
                            return response;
                        }
                        break;
                    case "update":
                        //data[fctn_local] = async function({id, payload}){
                        //    if(!payload) payload = {};
                        //    Object.assign(payload, this[nameService([name, "payload-local", service])]);
                        //    return await this[nameService([name, "set", key, "local", service])]({id, payload});
                        //}
                        //data[fctn_clrbl] = async function({id, payload}){
                        //    if(!payload) payload = {};
                        //    const fclr = nameService(name, key, "action-clearable");
                        //    this[fclr](fctn_local, payload);
                        //}
                        break;
                    case "delete":
                        break;
                    case "reset":
                        data[fctn_local] = function(){
                            switch(key){
                                case "array":
                                    this[nameService([name, key, "local", service])] = [];
                                    break;
                                default:
                                    this[nameService([name, key, "local", service])] = {};
                            }
                        }
                        break;
                    case "reload":
                        data[fctn_local] = async function({id, payload}){
                            if(!payload) payload = {};

                            return await this[nameService([name, "set", key, "local", service])]({id, payload});
                        }
                        data[fctn_clrbl] = async function({id, payload}){
                            if(!payload) payload = {};
                            const fclr = nameService([name, key, "action-clearable"]);
                            this[fclr](fctn_local, {id, payload});
                        }

                        data[nameService([name, key, "crud-reload"])] = function({id, payload}){
                            const fclr = undefined;
                            this[fclr](fctn_local, {id, payload})
                        }

                        break;
                    default:
                        data[fctn_local] = async function({next, id, payload}){
                            return await this[fctn_state]({next, id, payload, cancelid: this[nameService([name, "cancel-id", service])]});
                        }
                }
            });
        });
    });
    return data;
};

export default (name, store, service) => {
    const newService = {
        data: () => { return Object.assign(service.data, data(name)); },
        emits: _.union(emits(name), service.emits || []),
        watch: Object.assign(watch(name), service.watch || {}),
        props: Object.assign(props(name), service.props || {}),
        computed: Object.assign(computed(name, store), service.computed || {}),
        methods: Object.assign(methods(name, store), service.methods || {}),
        components: service.components,
    };
    return newService;
}
